<template>
  <vehicle-status-panel title="捷卫士车辆状态查询" source="jws" :use-jws-api="true" />
</template>

<script>
import VehicleStatusPanel from '../components/VehicleStatusPanel'
export default {
  name: 'CheliangJwsStatus',
  components: { VehicleStatusPanel }
}
</script>
